import * as S from "./InfoList.style";
import { InfoItem } from "@/components/molecules/InfoItem";

interface InfoBoxProps {
  data: any;
}

export const InfoList = ({ data }: InfoBoxProps) => {
  return (
    <S.InfoList>
      {data.map((item: any, idx: number) => {
        return <InfoItem data={item} key={idx} />;
      })}
    </S.InfoList>
  );
};
